import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Czech pluralization for "day/days"
 * - 1 den (one day)
 * - 2-4 dny (two to four days)
 * - 5+ dní (five or more days)
 */
export function getCzechDaysText(count: number): string {
  if (count === 1) return "den"
  if (count >= 2 && count <= 4) return "dny"
  return "dní"
}
